import React from 'react';
import { Link } from 'react-router-dom';
import { PaymentLogo, LABELS } from '../common/PaymentIcon';

const PAYMENT_TYPES = ['chime', 'cashapp', 'btc', 'ltc', 'paypal'];

// Accurate SVG social icons
const FacebookIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const TelegramIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
  </svg>
);

const WhatsAppIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/>
  </svg>
);

const InstagramIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/>
  </svg>
);

const SOCIAL_LINKS = [
  {
    name: 'Facebook Main',
    href: 'https://www.facebook.com/profile.php?id=61563563582592',
    bg: 'linear-gradient(135deg, #1877F2, #0d5ec9)',
    Icon: FacebookIcon,
    label: 'Facebook (Main)',
  },
  {
    name: 'Facebook Official',
    href: 'https://www.facebook.com/OfficialApex77',
    bg: 'linear-gradient(135deg, #1877F2, #0d5ec9)',
    Icon: FacebookIcon,
    label: 'Facebook (Official)',
  },
  {
    name: 'Telegram Main',
    href: 'https://t.me/LegitOfficialApex99',
    bg: 'linear-gradient(135deg, #0088cc, #006aaa)',
    Icon: TelegramIcon,
    label: 'Telegram (Main)',
  },
  {
    name: 'Telegram Second',
    href: 'https://t.me/legitapex78',
    bg: 'linear-gradient(135deg, #0088cc, #006aaa)',
    Icon: TelegramIcon,
    label: 'Telegram (Second)',
  },
  {
    name: 'WhatsApp',
    href: 'https://wa.me/16463276684',
    bg: 'linear-gradient(135deg, #25D366, #128C7E)',
    Icon: WhatsAppIcon,
    label: 'WhatsApp',
  },
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/officialapexgaming7',
    bg: 'linear-gradient(135deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)',
    Icon: InstagramIcon,
    label: 'Instagram',
  },
];

export default function Footer() {
  return (
    <footer style={{ background: 'var(--bg-secondary)', borderTop: '1px solid var(--border)', padding: '60px 0 30px', marginTop: 60 }}>
      <div className="container">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 40, marginBottom: 40 }}>

          {/* Brand */}
          <div>
            <h3 style={{ fontFamily: 'var(--font-display)', fontSize: 20, marginBottom: 14, background: 'var(--gradient-primary)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>APEX GAMING</h3>
            <p style={{ color: 'var(--text-secondary)', fontSize: 14, lineHeight: 1.7 }}>
              Your premier destination for online gaming platforms, exclusive daily offers, and an unmatched gaming community experience.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{ fontFamily: 'var(--font-display)', fontSize: 13, color: 'var(--text-secondary)', marginBottom: 14, letterSpacing: '0.1em' }}>QUICK LINKS</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {[
                ['/platforms',   'Platforms'],
                ['/offers',      'Offers'],
                ['/games',       'Mini Games'],
              ['/wheel',       '🎡 Daily Wheel'],
                ['/memberships', 'Memberships'],
                ['/reviews',     'Reviews'],
                ['/deposit',     'Make Deposit'],
                ['/chat',        'Live Chat'],
                ['/about',       'About'],
              ].map(([path, label]) => (
                <Link key={path} to={path}
                  style={{ color: 'var(--text-secondary)', fontSize: 14, textDecoration: 'none', transition: 'color 0.2s' }}
                  onMouseEnter={e => e.target.style.color = 'var(--accent-cyan)'}
                  onMouseLeave={e => e.target.style.color = 'var(--text-secondary)'}>
                  {label}
                </Link>
              ))}
            </div>
          </div>

          {/* Social Media */}
          <div>
            <h4 style={{ fontFamily: 'var(--font-display)', fontSize: 13, color: 'var(--text-secondary)', marginBottom: 14, letterSpacing: '0.1em' }}>FOLLOW US</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {SOCIAL_LINKS.map(({ name, href, bg, Icon, label }) => (
                <a
                  key={name}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '9px 14px', background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 10, textDecoration: 'none', transition: 'all 0.2s' }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = '#f5c400'; e.currentTarget.style.transform = 'translateX(4px)'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.transform = 'translateX(0)'; }}
                >
                  {/* Accurate icon with real brand gradient */}
                  <div style={{ width: 34, height: 34, borderRadius: 8, background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <Icon />
                  </div>
                  <span style={{ fontSize: 13, color: 'var(--text-secondary)', fontWeight: 600 }}>{label}</span>
                  <span style={{ marginLeft: 'auto', fontSize: 12, color: 'var(--text-muted)' }}>↗</span>
                </a>
              ))}
            </div>
          </div>

          {/* Payment Methods */}
          <div>
            <h4 style={{ fontFamily: 'var(--font-display)', fontSize: 13, color: 'var(--text-secondary)', marginBottom: 14, letterSpacing: '0.1em' }}>PAYMENT METHODS</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {PAYMENT_TYPES.map(type => (
                <div key={type}
                  style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 10px', background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 10, transition: 'border-color 0.2s' }}
                  onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--border-glow)'}
                  onMouseLeave={e => e.currentTarget.style.borderColor = 'var(--border)'}>
                  <PaymentLogo type={type} size={28} />
                  <span style={{ fontSize: 14, color: 'var(--text-secondary)', fontWeight: 600 }}>{LABELS[type]}</span>
                </div>
              ))}
            </div>
            <Link to="/deposit"
              style={{ display: 'inline-flex', alignItems: 'center', gap: 8, marginTop: 14, background: 'linear-gradient(135deg,#10b981,#059669)', color: '#fff', padding: '10px 18px', borderRadius: 10, fontWeight: 700, fontSize: 14, textDecoration: 'none', transition: 'opacity 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.opacity = '0.88'}
              onMouseLeave={e => e.currentTarget.style.opacity = '1'}>
              💰 Make a Deposit
            </Link>
          </div>

        </div>

        {/* Bottom bar */}
        <div style={{ borderTop: '1px solid var(--border)', paddingTop: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
          <p style={{ color: 'var(--text-muted)', fontSize: 13 }}>© {new Date().getFullYear()} Apex Gaming. All rights reserved.</p>
          <p style={{ color: 'var(--text-muted)', fontSize: 13 }}>For entertainment purposes only. 18+ only.</p>
        </div>
      </div>
    </footer>
  );
}
